<template>
    <div
        class="l-ss-c-results-info"
        :class="{
            'l-ss-c-results-info-with-message': hasAutocompleteElements || !totalItemsCount,
            'l-ss-c-results-info-only-results': totalItemsCount && !hasAutocompleteElements && !hasTips,
            'l-ss-c-results-info-with-tips': hasTips,
            'l-ss-c-results-info-with-autocomplete': hasAutocompleteElements,
        }">
        <div
            class="l-ss-c-results-info-header"
            v-if="message || hasAutocompleteElements">
            <span
                v-if="message"
                class="l-ss-c-results-info-help-text"
                v-html="message">
            </span>

            <span
                class="l-ss-c-results-info-autocomplete-items"
                v-if="hasAutocompleteElements && !isStandardSearchType">
                <span
                    v-for="item in list"
                    :key="item"
                    class="l-ss-c-results-info-autocomplete-item"
                    @click="() => handleSearch(item)">{{ item }}
                </span>
            </span>
        </div>

        <!-- <section-results-info-tips
            v-if="hasTips"
            :search="search"
            @handle-tags-click="$emit('handle-tags-click', $event)"
            @result-tab-click="$emit('result-tab-click', $event)"/> -->

        <div
            class="l-ss-c-results-info-count"
            v-if="totalItemsCount">
            {{ foundItemsMessage }}
        </div>
    </div>
</template>

<script>
    import { ref, computed, watch } from '@vue/composition-api';
    // import SectionResultsInfoTips from '@/core/components/section-results/section-results-info-tips.vue';
    import getDeclension from '@/core/helpers/get-declension';
    import debounce from '@/core/helpers/debounce.js';

    export default {
        components: {
            // SectionResultsInfoTips,
        },
        props: {
            search: {
                type: Object,
            },
            totalItemsCount: {
                type: Number,
                default: 0,
            },
            activeFilters: {
                type: Array,
            },
        },
        setup(props, { emit, root }) {
            const SET_FOUND_ITEMS_MESSAGE_DELAY = 200;

            const foundItemsMessage = ref('');

            const hasAutocompleteElements = computed(() => {
                return false;
            });

            const list = computed(() => {
                return props.search?.suggestions || [];
            });

            const hasTips = computed(() => {
                return !!props.search?.tips?.length;
            });

            const isStandardSearchType = computed(() => {
                const searchType = props.search?.meta?.searchType;
                const excludedKeywords = ['narrow', 'chat-gpt', 'image'];

                return searchType && !searchType.some(type => excludedKeywords.some(keyword => type.includes(keyword)));
            });

            const message = computed(() => {
                if (!props.totalItemsCount) {
                    return root.$t('noResultsFoundMessage', { 0: props.search.query });
                }

                return '';
            });

            const setFoundItemsMessage = () => {
                const foundItemsDeclensions = [
                    root.$t('results.foundNumberItems.declension.first', [props.totalItemsCount]),
                    root.$t('results.foundNumberItems.declension.second', [props.totalItemsCount]),
                    root.$t('results.foundNumberItems.declension.third', [props.totalItemsCount]),
                ];

                const foundCategoryDeclension = [
                    root.$t('results.foundNumberItems.categoryDeclension.first'),
                    root.$t('results.foundNumberItems.categoryDeclension.second'),
                    root.$t('results.foundNumberItems.categoryDeclension.second'),
                ];

                const activeCategoriesLength = props.activeFilters?.find((filter) => filter.field === 'category')?.options.length || 0;
                const categoriesCount = activeCategoriesLength || props.search.categories.length;
                const foundItemsDeclension = getDeclension(props.totalItemsCount, foundItemsDeclensions);
                const categoryDeclension = getDeclension(categoriesCount, foundCategoryDeclension);

                foundItemsMessage.value = `${foundItemsDeclension} ${categoryDeclension}:`;
            };

            const debouncedSetFoundItemsMessage = debounce(setFoundItemsMessage, SET_FOUND_ITEMS_MESSAGE_DELAY);

            setFoundItemsMessage();

            watch(() => props.totalItemsCount,
                  () => {
                      debouncedSetFoundItemsMessage();
                  },
            );

            watch(() => props.activeFilters,
                  () => {
                      debouncedSetFoundItemsMessage();
                  },
            );

            const handleSearch = (value) => {
                emit('autocomplete-search', value);
            };

            return {
                hasAutocompleteElements,
                list,
                hasTips,
                message,
                foundItemsMessage,
                handleSearch,
                isStandardSearchType,
            };
        },
    };
</script>
